import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VParallax } from 'vuetify/lib/components/VParallax';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
import { VTabsItems } from 'vuetify/lib/components/VTabs';
import { VTabsSlider } from 'vuetify/lib/components/VTabs';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c(VContainer, {
    staticClass: "pa-0 dtwin-form",
    style: !_vm.twinCanBeEdited ? 'opacity: 0.9' : '',
    attrs: {
      "fluid": ""
    }
  }, [_c('core-prompt', {
    attrs: {
      "title": _vm.$i18n_t('DigitalTwin.VirtualDevice.unsavedTitle'),
      "open": _vm.unsavedPrompt,
      "buttons": [{
        text: _vm.$i18n_t('Common.close'),
        emit: 'cancel'
      }, {
        text: _vm.$i18n_t('NiotaClassic.DeviceTypes.form.parser.switchParserPromptConfirm'),
        color: 'danger',
        emit: 'discard-changes'
      }]
    },
    on: {
      "cancel": function ($event) {
        _vm.unsavedPrompt = false;
      },
      "discard-changes": function ($event) {
        return _vm.unsavePromptNextPersist();
      }
    }
  }, [_vm._v("\n    " + _vm._s(_vm.$i18n_t('DigitalTwin.VirtualDevice.unsavedText')) + "\n  ")]), _c('core-prompt', {
    attrs: {
      "title": _vm.$i18n_t('DigitalTwin.DigitalTwin.twinDisableConfirmation'),
      "open": _vm.disableDialog,
      "color": "red",
      "buttons": [{
        text: _vm.$i18n_t('Common.cancel'),
        emit: 'cancel'
      }, {
        text: _vm.$i18n_t('DigitalTwin.DigitalTwin.twinDisable'),
        color: 'red',
        emit: 'disable'
      }]
    },
    on: {
      "close": function ($event) {
        _vm.disableDialog = false;
      },
      "disable": _vm.dialogDisable
    }
  }, [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.$i18n_t('DigitalTwin.DigitalTwin.twinDisableConfirmText'))
    }
  })]), _c(VDialog, {
    attrs: {
      "max-width": "900"
    },
    model: {
      value: _vm.exportDialog,
      callback: function ($$v) {
        _vm.exportDialog = $$v;
      },
      expression: "exportDialog"
    }
  }, [_vm.exportDialog ? _c('core-dtwin-csv-exportd', {
    attrs: {
      "dtwinId": _vm.twinObject.id,
      "tenantId": _vm.twinObject.tenantId,
      "ressource": "virtual-device-state-values"
    },
    on: {
      "close-export-dialog": function ($event) {
        _vm.exportDialog = false;
      }
    }
  }) : _vm._e()], 1), _c(VForm, {
    ref: "form",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "lazy-validation": ""
    },
    nativeOn: {
      "submit": function ($event) {
        return (e => e.preventDefault()).apply(null, arguments);
      }
    },
    model: {
      value: _vm.valid,
      callback: function ($$v) {
        _vm.valid = $$v;
      },
      expression: "valid"
    }
  }, [_c(VRow, {
    staticClass: "pb-0 mx-0",
    staticStyle: {
      "min-width": "0"
    }
  }, [_vm.showHeaderMap ? _c('core-dtwin-map-header-map', {
    style: `width: 100%; ${!_vm.twinCanBeEdited ? 'opacity: 0.5' : ''}`,
    attrs: {
      "header": "",
      "geoCoordinates": _vm.dtwinCoordinates,
      "dtwTitle": _vm.twinObject.title,
      "dtwData": _vm.twinObject.data,
      "mapInteractive": false,
      "overlayInfo": _vm.dtwinOverlayInfo
    },
    on: {
      "polygonUpdated": _vm.dtwinGeopolygonUpdated,
      "markerUpdated": _vm.dtwinCoordinateUpdated
    },
    scopedSlots: _vm._u([_vm.deviceTemplate ? {
      key: "deviceTemplateLink",
      fn: function () {
        return [_c('div', {
          staticClass: "ml-n2 mt-12 dtwin-subtitle-frame header-frame text-truncate"
        }, [_c(VIcon, {
          attrs: {
            "small": ""
          }
        }, [_vm._v("fa-sitemap")]), _vm._v("\n            " + _vm._s(_vm.$i18n_t('DigitalTwin.DigitalTwin.metaInfo.linkedToTemplate')) + ":\n            "), _c('router-link', {
          attrs: {
            "to": `/device-templates/${_vm.deviceTemplate.id}?tab=tab-device-meta`
          }
        }, [_vm._v("\n              " + _vm._s(_vm.deviceTemplate.title) + "\n            ")])], 1)];
      },
      proxy: true
    } : null], null, true)
  }) : _vm._e(), !_vm.showHeaderMap && _vm.headerBG ? _c(VCol, {
    staticClass: "pa-0"
  }, [_c(VParallax, {
    style: `width: 100%; ${!_vm.twinCanBeEdited ? 'opacity: 0.5' : ''}`,
    attrs: {
      "height": "240",
      "src": _vm.headerBG
    }
  }, [_c('h3', {
    staticClass: "pl-3 pr-3 header-text dtwin-title-frame text-truncate"
  }, [_vm.twinObject.data.faIcon && _vm.twinObject.data.faIcon.trim().length > 0 ? _c(VIcon, {
    class: _vm.color + '--text headline-icon mr-1',
    domProps: {
      "textContent": _vm._s(`fal fa-${_vm.twinObject.data.faIcon}`)
    }
  }) : _vm._e(), _vm._v("\n            " + _vm._s(_vm.twinObject.title) + "\n          ")], 1)])], 1) : _vm._e(), !_vm.showHeaderMap && !_vm.headerBG ? _c(VCol, {
    staticClass: "pa-0"
  }, [_c('div', {
    staticStyle: {
      "height": "143px"
    }
  }, [_c('h3', {
    staticClass: "pl-3 pr-3 header-text dtwin-title-frame text-truncate"
  }, [_vm.twinObject.data.faIcon && _vm.twinObject.data.faIcon.trim().length > 0 ? _c(VIcon, {
    class: _vm.color + '--text headline-icon mr-1',
    domProps: {
      "textContent": _vm._s(`fal fa-${_vm.twinObject.data.faIcon}`)
    }
  }) : _vm._e(), _vm._v("\n            " + _vm._s(_vm.twinObject.title) + "\n          ")], 1), _vm.deviceTemplate ? _c('div', {
    staticClass: "pl-3 pr-3 dtwin-subtitle-frame text-truncate"
  }, [_c(VIcon, {
    attrs: {
      "small": ""
    }
  }, [_vm._v("fa-sitemap")]), _vm._v("\n            " + _vm._s(_vm.$i18n_t('DigitalTwin.DigitalTwin.metaInfo.linkedToTemplate')) + ":\n            "), _c('router-link', {
    attrs: {
      "data-cy": "linked_to_template",
      "to": `/device-templates/${_vm.deviceTemplate.id}?tab=tab-device-meta`
    }
  }, [_vm._v("\n              " + _vm._s(_vm.deviceTemplate.title) + "\n            ")])], 1) : _vm._e()])]) : _vm._e()], 1), _c('div', _vm._b({}, 'div', _vm.actionBoxClass, false), [_c('div', {
    class: `px-2 ${_vm.actionBoxGradientClass}`,
    staticStyle: {
      "height": "60px"
    }
  }, [_c('core-favoriteselect', {
    staticClass: "ml-1 mr-1",
    attrs: {
      "objectId": _vm.twinObject.id || NaN,
      "type": "digitalTwin",
      "asRoundButton": ""
    }
  }), _vm.twinCanBeEdited ? _c('core-button', {
    attrs: {
      "title": _vm.$i18n_t('Common.save'),
      "color": _vm.color,
      "disabled": !_vm.valid || _vm.cloading,
      "type": "submit",
      "solid-icon": "",
      "prepend-icon": "fa-save",
      "data-cy": "save-vd-button"
    },
    on: {
      "click": _vm.handleSubmit
    }
  }) : _vm._e(), _c('core-button', {
    attrs: {
      "title": _vm.$i18n_t('Common.cancel'),
      "color": "danger",
      "disabled": _vm.cloading,
      "prepend-icon": "fa-times"
    },
    on: {
      "click": function ($event) {
        return _vm.$router.push({
          path: `/${_vm.baseLink}`,
          query: {
            openTree: _vm.openTree,
            active: _vm.activeId
          }
        });
      }
    }
  })], 1)]), _c(VRow, {
    staticClass: "n20-mainrow pb-4 pt-1",
    staticStyle: {
      "min-width": "0"
    }
  }, [_c(VCol, {
    attrs: {
      "cols": "12"
    }
  }, [_c(VCard, {
    staticClass: "mb-8"
  }, [_c(VCardText, [_c(VTabs, {
    class: {
      sm: _vm.$vuetify.breakpoint.smAndDown
    },
    attrs: {
      "show-arrows": ""
    },
    model: {
      value: _vm.tabItem,
      callback: function ($$v) {
        _vm.tabItem = $$v;
      },
      expression: "tabItem"
    }
  }, [_c(VTabsSlider, {
    attrs: {
      "color": _vm.color
    }
  }), _c(VTab, {
    attrs: {
      "href": "#tab-dashboard"
    }
  }, [_vm._v("\n                " + _vm._s(_vm.$i18n_t('Common.drawer.twinDashboard')) + "\n              ")]), _c(VTab, {
    attrs: {
      "href": "#tab-main",
      "data-cy": "tab-main"
    }
  }, [_vm._v("\n                " + _vm._s(_vm.$i18n_t('Common.digitalTwins.dtwinInformation')) + "\n              ")]), _c(VTab, {
    attrs: {
      "href": "#tab-details",
      "data-cy": "tab-details"
    }
  }, [_vm._v("\n                " + _vm._s(_vm.$i18n_t('Common.digitalTwins.dtwinDetails')) + "\n              ")]), _c(VTab, {
    attrs: {
      "href": "#tab-deviceinfo",
      "data-cy": "tab-deviceinfo"
    }
  }, [_vm._v("\n                " + _vm._s(_vm.$i18n_t('DigitalTwin.VirtualDevice.details.deviceInfo')) + "\n              ")]), _c(VTab, {
    attrs: {
      "href": "#tab-states",
      "data-cy": "tab-states"
    }
  }, [_vm._v("\n                " + _vm._s(_vm.$i18n_t('DigitalTwin.DigitalTwin.dataStates')) + "\n              ")]), _c(VTab, {
    attrs: {
      "href": "#tab-rules",
      "data-cy": "tab-rules"
    }
  }, [_vm._v("\n                " + _vm._s(_vm.$i18n_t('DigitalTwin.DigitalTwin.ruleModeler.tabItem')) + "\n              ")]), _c(VTab, {
    attrs: {
      "href": "#tab-data-routing",
      "data-cy": "tab-data-routing"
    }
  }, [_vm._v("\n                " + _vm._s(_vm.$i18n_t('DigitalTwin.DigitalTwin.dataRouting.tabItem')) + "\n              ")]), _c(VTabsItems, {
    attrs: {
      "touchless": ""
    },
    model: {
      value: _vm.tabItem,
      callback: function ($$v) {
        _vm.tabItem = $$v;
      },
      expression: "tabItem"
    }
  }, [_c(VTabItem, {
    key: "dashboard",
    attrs: {
      "value": "tab-dashboard"
    }
  }, [_c('core-n20Card', {
    staticClass: "mt-4 dt-card-text-01"
  }, [_c(VRow, [_c(VCol, {
    staticClass: "mb-0 mt-0",
    attrs: {
      "cols": "12",
      "sm": "6",
      "md": "3",
      "lg": "2"
    }
  }, [_c('custom-fields-display-field', {
    attrs: {
      "label": _vm.$i18n_t('Common.id'),
      "value": _vm.twinObject.id,
      "iconColor": _vm.color,
      "icon": "file-excel",
      "type": "icon"
    }
  })], 1), _vm.twinObject.data.virtualDevice && _vm.twinObject.data.virtualDevice.operationalStatus !== undefined ? _c(VCol, {
    staticClass: "mb-0",
    attrs: {
      "cols": "12",
      "sm": "6",
      "md": "3",
      "lg": "2"
    }
  }, [_c('custom-fields-display-field', {
    attrs: {
      "label": _vm.$i18n_t('NiotaClassic.Devices.details.operationalStatus'),
      "value": _vm.operationalStatus[parseInt(_vm.twinObject.data.virtualDevice.operationalStatus)] || _vm.twinObject.data.virtualDevice.operationalStatus,
      "iconColor": _vm.color,
      "icon": "heart-rate",
      "type": "icon"
    }
  })], 1) : _vm._e(), _vm.twinObject.data.virtualDevice ? _c(VCol, {
    staticClass: "mb-0",
    attrs: {
      "cols": "12",
      "sm": "6",
      "md": "3",
      "lg": "2"
    }
  }, [_c('custom-fields-display-field', {
    attrs: {
      "label": _vm.$i18n_t('DigitalTwin.VirtualDevice.details.lastSeen'),
      "value": _vm.relativeTime(_vm.lastRawStateUpdate),
      "iconColor": _vm.color,
      "icon": "heart-rate",
      "type": "icon"
    }
  })], 1) : _vm._e()], 1)], 1), _c('core-dtwin-state-preview-db-tiles', {
    staticClass: "mt-2",
    attrs: {
      "twinDataStates": _vm.twinDataStates,
      "updatedStates": _vm.updatedStates,
      "loading": _vm.isLoadingStates,
      "noDataAlert": ""
    },
    on: {
      "didUpdateStates": _vm.didUpdateStates
    }
  })], 1), _c(VTabItem, {
    key: "main",
    attrs: {
      "value": "tab-main"
    }
  }, [_c('core-dtwin-edit-information', {
    attrs: {
      "twinObject": _vm.twinObject,
      "account": _vm.account,
      "deviceTemplate": _vm.deviceTemplate,
      "hasTwinManagePermission": _vm.hasTwinManagePermission && _vm.twinCanBeEdited,
      "hasTwinEditPermission": _vm.twinCanBeEdited,
      "hasUserReadPermission": _vm.permissions['UserManagement.read'],
      "hideFields": ['type', 'scope-edit', 'referenceIds'],
      "tagListType": "virtualDevice",
      "hasVisibleParent": ""
    }
  })], 1), _c(VTabItem, {
    key: "details",
    attrs: {
      "value": "tab-details"
    }
  }, [_vm.twinObject.id ? _c(VRow, [_c(VCol, [_c('core-dtwin-geo-details', {
    attrs: {
      "dataInstance": _vm.wrappedInstance,
      "twinObject": _vm.twinObject,
      "twinImages": _vm.twinImages,
      "twinCanBeEdited": _vm.twinCanBeEdited,
      "hasFloorTwinReadPermissions": _vm.hasFloorTwinReadPermissions,
      "floorTwinOverlayData": _vm.floorTwinOverlayData
    }
  })], 1)], 1) : _vm._e()], 1), _c(VTabItem, {
    key: "deviceinfo",
    attrs: {
      "value": "tab-deviceinfo"
    }
  }, [_vm.twinObject.data.virtualDevice && _vm.twinDataStates.length > 0 ? _c('core-virtual-device-tab', {
    attrs: {
      "dtwin": _vm.twinObject,
      "deviceTemplate": _vm.deviceTemplate,
      "twinDataStates": _vm.twinDataStates,
      "bridgeCreateFields": _vm.bridgeCreateFields,
      "bridgeReadMethod": _vm.bridgeReadMethod,
      "bridgeUpdateMethod": _vm.bridgeUpdateMethod,
      "bridgeCreateParameters": _vm.bridgeCreateParameters,
      "connectedBridge": _vm.connectedBridge,
      "bridgeManifest": (_vm.bridgeConfig || {}).manifest,
      "hasTwinManagePermission": _vm.twinCanBeEdited && _vm.hasTwinManagePermission,
      "hasVirtualDeviceKeyReaderPermission": _vm.hasVirtualDeviceKeyReaderPermission,
      "savedDeviceTypeId": _vm.get(_vm.originalTwinObject, 'data.virtualDevice.deviceTypeId'),
      "savedDeviceDriverId": _vm.get(_vm.originalTwinObject, 'data.virtualDevice.deviceDriverId')
    },
    on: {
      "unlink-device-template": _vm.onUnlinkDeviceTeTemplate,
      "change-device-driver": _vm.onChangeDeviceDriver,
      "change-device-type": _vm.onChangeDeviceType,
      "change-bridge-params": _vm.onChangedBridgeParams
    }
  }) : _c('core-virtual-device-tab-loading')], 1), _c(VTabItem, {
    key: "states",
    attrs: {
      "value": "tab-states"
    }
  }, [_vm.twinObject.tenantId ? _c('core-dtwin-state-table', {
    ref: "stateTable",
    attrs: {
      "updatedStates": _vm.updatedStates,
      "disabled": _vm.dtwinIsDisabled,
      "hasTwinManagePermission": _vm.twinCanBeEdited && _vm.hasTwinManagePermission,
      "hasTwinEditPermission": _vm.twinCanBeEdited,
      "tenantId": _vm.twinObject.tenantId,
      "twinModel": _vm.twinObject,
      "deviceTemplate": _vm.deviceTemplate,
      "isVirtualDevice": ""
    },
    on: {
      "statesUpdated": _vm.refreshStates,
      "refresh": _vm.refreshStates,
      "finishedLoading": _vm.finishedLoadingStatesTable,
      "showExportModal": _vm.showExportModal
    },
    model: {
      value: _vm.twinDataStates,
      callback: function ($$v) {
        _vm.twinDataStates = $$v;
      },
      expression: "twinDataStates"
    }
  }) : _vm._e()], 1), _c(VTabItem, {
    key: "rules",
    attrs: {
      "value": "tab-rules"
    }
  }, [_vm.twinObject.tenantId ? _c('core-dtwin-rule-table', {
    ref: "rulesTable",
    attrs: {
      "stateTable": _vm.$refs.stateTable,
      "disabled": _vm.dtwinIsDisabled,
      "hasTwinManagePermission": _vm.twinCanBeEdited && _vm.hasTwinManagePermission,
      "hasTwinEditPermission": _vm.twinCanBeEdited,
      "dtwin": _vm.twinObject,
      "template": _vm.deviceTemplate,
      "isCreatedByTemplate": !!_vm.deviceTemplate
    },
    model: {
      value: _vm.twinDataStates,
      callback: function ($$v) {
        _vm.twinDataStates = $$v;
      },
      expression: "twinDataStates"
    }
  }) : _vm._e()], 1), _c(VTabItem, {
    key: "data-routing",
    attrs: {
      "value": "tab-data-routing"
    }
  }, [_c(VRow, {
    staticClass: "ma-0 pa-0"
  }, [_c(VCol, {
    attrs: {
      "cols": "12"
    }
  }, [_c('core-dtwin-reference-ids', {
    attrs: {
      "value": _vm.twinObject['dynamical-data-routing-target'] || [],
      "disabled": !_vm.twinCanBeEdited,
      "type": 'virtualDevice',
      "tenantId": _vm.twinObject.tenantId,
      "requiredValueByKey": _vm.get(_vm.deviceTemplate, 'deviceMeta.referenceIds', null)
    },
    on: {
      "update": _vm.handleUpdate
    },
    scopedSlots: _vm._u([{
      key: "header",
      fn: function () {
        return [_c('h4', [_vm._v(_vm._s(_vm.$i18n_t('DigitalTwin.DigitalTwin.dataRouting.defineDestinations')))]), _c('p', {
          staticClass: "card-description my-0 mb-2"
        }, [_vm._v("\n                            " + _vm._s(_vm.$i18n_t('DigitalTwin.DigitalTwin.dataRouting.specifyReferenceIds')) + "\n                          ")])];
      },
      proxy: true
    }])
  })], 1)], 1)], 1)], 1)], 1)], 1)], 1)], 1)], 1)], 1)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };